module.exports = __webpack_public_path__ + "static/9-b4e143dcd1d9584371b33cfd30555c8e.png";